<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="800px"
  >
    <v-card>
      <v-toolbar color="primary" dark dense>
          <v-toolbar-title>{{ mode=='edit' ? 'Редактирование сотрудника ' : 'Новый сотрудник'}}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-title v-if="mode == 'edit'">
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>Контакты сотрудника</v-expansion-panel-header>
            <v-expansion-panel-content>
              <contactsLine :user="user" :mode="mode" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-title>
      <v-card-text class="mt-5">
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="loc_user.lastname"
              :disabled="mode == 'view'"
              dense
              label="Фамилия*"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="loc_user.firstname"
              :disabled="mode == 'view'"
              dense
              label="Имя*"
              hint="Имя сотрудника"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="loc_user.surname"
              :disabled="mode == 'view'"
              dense
              label="Отчество*"
              hint="Отчество сотрудника"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <org-position-select :org="org" v-model="loc_user.IPOS_ID" :mode="'edit'" />
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="loc_user.sexcode"
              :disabled="mode=='view'"
              dense
              :items="[{text: 'Мужской', value: '1'}, {text: 'Женский', value: '0'}]"
              label="Пол*"
              required
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" offset-sm="6">
            <v-text-field
              v-model="loc_user.EMP_SORT_NUM"
              dense
              type="number"
              step="1"
              label="Номер сотрудника"
              hint="Порядковый номер для сортировки (по подразделению)"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters v-if="mode == 'create'">
          <v-col cols="12" class="black--text font-weight-black">
            Контактная информация
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="loc_user.contacts.workphone"
              dense
              class="mr-3"
              label="Рабочий телефон"
              hint="Рабочий телефон сотрудника"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="loc_user.contacts.cellphone"
              dense
              label="Мобильный телефон"
              hint="Мобильный телефон сотрудника"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="loc_user.contacts.email"
              dense
              class="mr-3"
              label="Электронная почта сотрудника *"
              hint="Рабочая электронная почта сотрудника"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="loc_user.contacts.edo"
              dense
              label="Адрес ЭДО"
              hint="Адрес в системе ЭДО"
            ></v-text-field>
          </v-col>
        </v-row>
        <small>*Поля, обязательные для заполнения</small>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="blue darken-1"
          text
          @click="onCloseEvent(null)"
        >
          Закрыть
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="onSave"
          :disabled="!isFormValid"
          v-if="mode != 'view'"
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ORG_ADD_EMPLOEE, ORG_UPD_EMPLOEE } from '@/store/actions/org'
import { UI_SNACKBAR } from '@/store/actions/ui'
import OrgPositionSelect from '@/components/modules/org/clients/components/orgPositionSelect'

export default {
  name: 'addEmployeeDialog',
  props: ['value', 'org', 'division', 'user', 'mode'],
  components: {
    OrgPositionSelect,
    contactsLine: () => import('@/components/modules/org/structure/staff/userContactsLine.vue')
  },
  data: () => ({
    loc_user: {
      INST_UUID: -1,
      EMP_SORT_NUM: 0,
      EMP_ID: null,
      firstname: '',
      lastname: '',
      surname: '',
      sexcode: 1,
      contacts: {},
      IPOS_ID: null,
      ITP_ID: null
    }
  }),
  computed: {
    isFormValid: {
      get: function () {
        let emailPresent = false
        if (this.mode === 'edit') {
          emailPresent = this.loc_user.CONTACTS.find(item => ((item.CONT_TYPE === '0') && (item.CONT_IS_GEN === '1')))
        } else {
          emailPresent = this.loc_user.contacts.email
        }
        return this.loc_user.firstname && this.loc_user.lastname && this.loc_user.surname && this.loc_user.IPOS_ID && emailPresent
      }
    }
  },
  watch: {
    org (val) {
      if (val.INST_UUID) {
        this.loc_user.INST_UUID = this.org.INST_UUID
      } else {
        this.$emit('input', false)
      }
    },
    user (val) {
      console.log('User changed to ', val)
      if (val) {
        this.setUser(val)
      } else {
        this.clearForm()
      }
    }
  },
  methods: {
    setUser (val) {
      this.loc_user.INST_UUID = this.org.INST_UUID
      this.loc_user.CONTACTS = val.CONTACTS
      this.loc_user.EMP_ID = val.EMP_ID
      this.loc_user.EMP_SORT_NUM = val.EMP_SORT_NUM
      this.loc_user.firstname = val.EMP_NAME
      this.loc_user.lastname = val.EMP_LAST_NAME
      this.loc_user.surname = val.EMP_SNAME
      this.loc_user.sexcode = val.EMP_SEX
      this.loc_user.IPOS_ID = val.IPOS_ID
      this.loc_user.ITP_ID = val.ITP_ID
    },
    clearForm () {
      this.loc_user.INST_UUID = -1
      this.loc_user.EMP_ID = null
      this.loc_user.EMP_SORT_NUM = 0
      this.loc_user.firstname = ''
      this.loc_user.lastname = ''
      this.loc_user.surname = ''
      this.loc_user.IPOS_ID = null
      this.loc_user.ITP_ID = null
      this.loc_user.sexcode = 1
      this.loc_user.contacts = {}
    },
    onCloseEvent (data) {
      this.clearForm()
      this.$emit('input', false)
    },
    onSave () {
      if (this.mode === 'create') {
        this.onCreateEvent()
      }
      if (this.mode === 'edit') {
        this.onUpdateEvent()
      }
    },
    onCreateEvent () {
      // Сохраняем данные
      const payload = {
        ...this.loc_user, INST_UUID: this.org.INST_UUID, ITP_ID: this.division.ITP_ID
      }
      console.log('trying to add new employee ', payload)
      this.$store.dispatch(ORG_ADD_EMPLOEE, payload)
        .then((resp) => {
          this.$emit('onEmployeeAdded', resp)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка добавления сотрудника' + err })
          console.log('Ошибка ', err)
        })
    },
    onUpdateEvent () {
      // Сохраняем данные
      this.loc_user.ITP_ID = this.user.ITP_ID
      this.loc_user.EMP_ID = this.user.EMP_ID
      const payload = {
        INST_UUID: this.org.INST_UUID,
        EMP_NAME: this.loc_user.firstname,
        EMP_SNAME: this.loc_user.surname,
        EMP_LAST_NAME: this.loc_user.lastname,
        EMP_SEX: this.loc_user.sexcode,
        IPOS_ID: this.loc_user.IPOS_ID,
        EMP_ID: this.user.EMP_ID,
        EMP_SORT_NUM: this.loc_user.EMP_SORT_NUM
      }
      console.log('Saving user: ', payload)
      const that = this
      this.$store.dispatch(ORG_UPD_EMPLOEE, payload)
        .then((resp) => {
          that.$emit('onEmployeeUpdated', resp)
        })
        .catch((err) => {
          that.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка обновления сотрудника' + err })
          console.log('Ошибка ', err)
        })
    }
  },
  mounted: function () {
    console.log('addEmployeeDialog mounted. Org is ', this.org, ', division is ', this.division, ', user is ', this.user, ', mode is ', this.mode)
    if (this.user) this.setUser(this.user)
  }

}
</script>
